export const API_BASE = 'https://nameo-worker.benjamin-f-mcdaniel.workers.dev'
